<template>
  <div class="relative pb-48">
    <!-- {{ selectedLocation }} -->
    <ScanQRForm
      title="Scan QR Code Lokasi"
      @selected="
        (a) => {
          fetchForm(a);
          lokasi = a;
        }
      "
    />

    <hr class="mt-4 border-b bg-primary opacity-50 mx-4" />

    <template v-if="lokasi">
      <template v-for="a in forms">
        <ChecklistCleaningForm :data="a" :key="a.id" />
      </template>
    </template>

    <div class="fixed max-w-xl w-full bottom-0 bg-white px-2 py-4 flex items-end shadow-md shadow-primary">
      <div class="w-full pr-2">
        <p v-if="!allDone" class="text-sm text-danger">*Harap isi semua untuk mengirim</p>
      </div>

      <van-button
        :disabled="!allDone"
        :loading="isLoading"
        type="info"
        loading-type="spinner"
        class="whitespace-nowrap bg-primary border-none"
      >
        <v-icon icon="material-symbols:send" class="text-2xl mr-1 inline" />
        <span class="ml-2 font-bold">Simpan</span>
      </van-button>
    </div>
  </div>
</template>

<style scoped>
  .animate-flashing {
    animation: flashing 1s infinite;
  }

  @keyframes flashing {
    0% {
      --tw-bg-opacity: 1;
    }
    50% {
      --tw-bg-opacity: 0.1;
    }
    100% {
      --tw-bg-opacity: 1;
    }
  }
</style>

<script>
  import ScanQRForm from "@/components/Forms/ScanQRForm.vue";
  // import PictureForm from "@/components/Forms/PictureForm.vue";
  import ChecklistCleaningForm from "@/components/Forms/ChecklistCleaningForm.vue";

  import { location } from "@/states/location";
  import dayjs from "dayjs";
  import { users } from "@/states/user";
  // import { queueManager } from "@/states/local";

  import local from "@/states/local";
  // import { deleteUpload } from "@/plugins/axios";
  import instance from "@/plugins/axios";

  export default {
    name: "AttendancePage",
    components: {
      // PictureForm,
      ScanQRForm,
      ChecklistCleaningForm
    },

    data() {
      return {
        isLoading: false,
        lokasi: null,
        foto: [],
        forms: [],
        selectedLocation: null,
        tracking: location,
        local,
        users
      };
    },
    props: {
      isIn: {
        type: Boolean,
        default: true
      }
    },

    mounted() {},

    computed: {
      allDone() {
        return this.lokasi && this.foto.isPassLimit;
      }
    },

    methods: {
      // async submit() {
      //   const toasty = this.$toast.loading({ message: "Mengupload foto selfie...", forbidClick: true, duration: 0 });
      //   this.isLoading = true;

      //   const processedFoto = [];
      //   for (const x of this.foto.pictures) {
      //     const result = await local.processFile(x.picture).catch((err) => {
      //       console.error(err);
      //       toasty.clear();
      //       this.$toast.fail({ message: "Gagal mengupload foto", duration: 5000 });
      //       this.isLoading = false;
      //       return null;
      //     });
      //     processedFoto.push(result);
      //   }

      //   if (processedFoto.some((x) => !x)) {
      //     deleteUpload(processedFoto)
      //       .then(() => {
      //         toasty.clear();
      //         this.$toast.fail({ message: "Gagal mengupload foto. Coba lagi nanti...", duration: 5000 });
      //       })
      //       .catch(() => {});
      //     toasty.clear();
      //     this.isLoading = false;
      //     return;
      //   }

      //   console.log(processedFoto);
      //   toasty.message = "Mengirim data...";

      //   const coordCurrently = this.tracking;
      //   console.log(coordCurrently, this.tracking);

      //   local
      //     .processData(this.isIn ? "/attendance/assign/in" : "/attendance/assign/out", {
      //       location: this.lokasi,
      //       currentLocation: this.hasBypass()
      //         ? this.selectedLocation
      //         : [coordCurrently.latitude, coordCurrently.longitude],
      //       images: processedFoto,
      //       imageDescriptions: this.foto.pictures.map((x) => x.description)
      //     })
      //     .then(() => {
      //       this.isLoading = false;
      //       toasty.clear();
      //       this.$router.go(-1);
      //     })
      //     .catch((err) => {
      //       this.isLoading = false;
      //       toasty.message = "Gagal mengirim data. Menghapus foto...";
      //       deleteUpload(processedFoto)
      //         .then(() => {
      //           toasty.clear();
      //           this.$toast.fail({ message: "Gagal mengirim. Coba lagi nanti...", duration: 5000 });
      //         })
      //         .catch(() => {});

      //       console.error(err);
      //     });
      // },
      hasBypass() {
        return this.users.data?.occupationPermission?.includes("explicitNoLocation");
      },
      fetchForm(e) {
        console.log(e);
        instance
          .get("/report/cleaning/form/" + e)
          .then((res) => {
            this.forms = res.data;
          })
          .catch((err) => {
            console.error(err);
          });
      },
      formatTime(time, format = "HH:mm") {
        return dayjs(time).format(format);
      }
    }
  };
</script>
